import {API_BASE} from '../config/ApiConfig';

export class JourneyContoller {

  async getAllBooking(token) {
    return fetch(API_BASE + '/booking/attended', {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json',
      },
    })
      .then(response => response.json())
      .then(responseJson => {
        return responseJson;
      })
      .catch(error => {
        console.log(error);
        return {success: false, error};
      });
  }
  async getAllBedges(token) {
    console.log(token,'token')
    return fetch(API_BASE + '/badges', {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json',
      },
    })
      .then(response => response.json())
      .then(responseJson => {
        return responseJson;
      })
      .catch(error => {
        console.log(error);
        return {success: false, error};
      });
  }

}